import { AutoLoader } from '../../../shared/src/API/APIAutoloader.js';
import { simplePostRequestWithBody, handleErrors, simpleGetRequest, fetchRequest } from '../../../shared/src/API/baseAPI.js';
import { createReviewCard } from '../../../shared/src/components/ReviewCard/reviewCard.js';
import eventBus from '../../../shared/src/events/eventBus.js';
import { showAlert } from '../../../shared/src/Util/alerts.js';
import { getQueryParams, isDarkMode } from '../../../shared/src/Util/helper.js';

export function submitCity() {
    const name = document.getElementById('name').value;
    const state = document.getElementById('state').value;
    const country = document.getElementById('country').value;
    const zipEl = document.getElementById('zip');
    const zip = zipEl ? zipEl.value : '';

    if (!name || !state || !country) {
        showAlert(t('city.fillAllFields'), 'warning');
        return;
    }

    // check if name and state may have switched places accidentally
    const nameContainsNumbers = /\d/.test(name);
    if (nameContainsNumbers) {
        showAlert(t('city.noNumbers'), 'warning');
        return;
    }

    const editorMode = window.cityEditorMode || 'new';

    if (editorMode === 'edit') {
        const originalName = window.originalCityName;
        if (!originalName) {
            showAlert(t('errors.invalidInput'), 'error');
            return;
        }

        const patch = {
            cityName: name,
            state,
            country,
        };

        fetchRequest('PUT', `/api/v1/city/name/${encodeURIComponent(originalName)}`, patch, { 'Content-Type': 'application/json' }, 'citySubmit', handleCityResponse, true);
        return;
    }

    const data = { name, state, country, zip };
    simplePostRequestWithBody('/api/v1/city/new', data, 'citySubmit', handleCityResponse);
}

export function handleCityResponse(res) {
    if (res.error) {
        handleErrors(res);
        return;
    }

    const editorMode = window.cityEditorMode || 'new';
    const payload = res.data || {};
    const createdCities = Array.isArray(payload.cities) ? payload.cities : [];
    const warnings = Array.isArray(payload.warnings) ? payload.warnings : [];

    if (warnings.length > 0) {
        const first = warnings[0];
        const near = first.overlaps.map(o => `${o.cityName} (${o.zip}, ~${o.distanceMeters}m)`).join(', ');
        showAlert(t('city.overlapWarning', { cityName: first.cityName, zip: first.zip, near }), 'warning');
    }

    if (editorMode === 'edit') {
        showAlert(t('city.saved') || 'Saved', 'success');
        const newName = document.getElementById('name')?.value;
        if (newName) {
            window.location.href = `/city/${encodeURIComponent(newName)}`;
        }
        return;
    }

    if (createdCities.length > 0) {
        showAlert(t('city.created') || 'Created', 'success');
        clearInputs();
    }

    if (res.message) {
        showAlert(res.message, 'info');
    }

    // If cities are returned, add them to the list without overwriting the existing ones
    if (createdCities.length > 0) {
        const citiesList = document.getElementById('citiesList');
        const noCities = document.getElementById('noCities');
        noCities.classList.add('hidden');
        createdCities.forEach(city => {
            const cityElement = document.createElement('a');
            cityElement.innerText = `${city.zip}, ${city.name} (${city.state}, ${city.country})`;
            cityElement.href = `/city/${encodeURIComponent(city.cityName || city.name || city.zip)}`;
            citiesList.appendChild(cityElement);
        });
    }
}

export function clearInputs() {
    document.getElementById('newCityForm').reset();
}

function updateBBox() {
    const raw = city.bbox;
    if (!Array.isArray(raw) || raw.length < 4) {
        return;
    }

    const n = raw.slice(0, 4).map((v) => Number(v));
    if (!n.every((v) => Number.isFinite(v))) {
        return;
    }

    let minLon, minLat, maxLon, maxLat;
    const looksLikeLatLatLonLon = Math.abs(n[0]) <= 90 && Math.abs(n[1]) <= 90 && Math.abs(n[2]) <= 180 && Math.abs(n[3]) <= 180;
    if (looksLikeLatLatLonLon) {
        minLat = Math.min(n[0], n[1]);
        maxLat = Math.max(n[0], n[1]);
        minLon = Math.min(n[2], n[3]);
        maxLon = Math.max(n[2], n[3]);
    } else {
        minLon = Math.min(n[0], n[2]);
        maxLon = Math.max(n[0], n[2]);
        minLat = Math.min(n[1], n[3]);
        maxLat = Math.max(n[1], n[3]);
    }

    const label = document.getElementById('bboxLabel');
    if (label) {
        label.textContent = `${minLon.toFixed(3)},${minLat.toFixed(3)} → ${maxLon.toFixed(3)},${maxLat.toFixed(3)}`;
    }
}
let map;
function initMap() {
    const lat = city.latitude;
    const long = city.longitude;

    map = L.map('cityMap', {
        zoomControl: false,
        minZoom: 5,
        maxZoom: 20,
    }).setView([lat || 49.5897, long || 11.0120], 10);

    setLayer(isDarkMode()? 'streets-v2-dark' : 'streets-v2');
}

eventBus.on('theme:switch', (data) => {
    if (map) {
        setLayer(data.theme === 'dark' ? 'streets-v2-dark' : 'streets-v2');
    }
});

let currentLayer;
function setLayer(style) {
    if (currentLayer) {
        map.removeLayer(currentLayer);
    }

    // Create a MapTiler Layer inside Leaflet
    currentLayer = new L.maptiler.maptilerLayer({
        apiKey: mapsAPIKey,
        style,
        maxZoom: 20,
        attribution: `&copy; <a href="https://www.maptiler.com/copyright/" target="_blank">MapTiler</a>
            &copy; <a href="https://www.openstreetmap.org/copyright" target="_blank">OpenStreetMap</a>`
    }).addTo(map);
}
const filter = {};
let listPage = 1;
let fullyLoaded = false;
let autoLoader = null;

function loadCarousel() {
    const headers = {
        'Content-Type': 'application/json',
        'data': JSON.stringify(filter)
    }

    if (fullyLoaded) {
        autoLoader.destroy();
        return;
    }

    fetchRequest('GET', '/api/v1/reviews', null, headers, 'reviewSkeleton', handleData, true);
}

function handleData(res) {
    if (res.error) {
        fullyLoaded = true;
        hideSkeleton();
        handleErrors(res);
        return;
    }

    listPage += 1;
 
    if (res.data.length < 10) {
        fullyLoaded = true;
        hideSkeleton();
    }

    res.data.forEach((review) => {
        createReviewCard(review, 'carousel', 'reviewSkeleton');
    });

    if (res.data.length === 0 && listPage === 2) {
        const noReviews = document.getElementById('noReviews');
        noReviews.classList.remove('hidden');
    }
}

function hideSkeleton() {
    const skeleton = document.getElementById('reviewSkeleton');
    if (skeleton) {
        skeleton.classList.add('hidden');
    }
}

document.addEventListener('DOMContentLoaded', () => {
    if (document.getElementById('cityMap')) {
        initMap();
    }

    if (document.getElementById('bboxLabel')) {
        updateBBox();
    }

    if (document.getElementById('carousel')) {
        console.log(city.bbox)
        filter.bbox = city.bbox.join(',');
        filter.city = city.cityName;
        filter.page = listPage;
        filter.limit = 10;
        filter.star = 0;
        filter.sort = 'newest';
        filter.price = -1;
        filter.meat = [];
        filter.filters = [];
        filter.query = '';
        filter.zip = city.zips[0].toString() || '91054';

        autoLoader = new AutoLoader('reviewSkeleton', loadCarousel)
    }

    // City-name suggestions (new/edit city page)
    const nameInput = document.getElementById('name');
    if (nameInput && (window.cityEditorMode === 'new' || window.cityEditorMode === 'edit')) {
        let lastSuggested = '';
        nameInput.addEventListener('blur', async () => {
            const q = nameInput.value || '';
            if (!q.trim() || q === lastSuggested) return;

            fetchRequest(
                'GET',
                `/api/v1/city/suggest?q=${encodeURIComponent(q)}&limit=5`,
                null,
                null,
                null,
                (res) => {
                    if (res?.data?.suggestions && Array.isArray(res.data.suggestions) && res.data.suggestions.length > 0) {
                        const suggestions = res.data.suggestions;
                        if (!suggestions.includes(q)) {
                            lastSuggested = q;
                            showAlert(t('city.didYouMean', { suggestions: suggestions.join(', ') }), 'info');
                        }
                    }
                },
                true
            );
        });
    }

    // Admin actions (city page)
    if (typeof isAdmin !== 'undefined' && isAdmin && typeof city !== 'undefined' && city?.cityName) {
        const mergeBtn = document.getElementById('mergeCityBtn');
        const deleteBtn = document.getElementById('deleteCityBtn');

        if (mergeBtn) {
            mergeBtn.addEventListener('click', async () => {
                const target = window.prompt(t('city.admin.mergePrompt'), city.cityName);
                if (!target || !target.trim() || target.trim() === city.cityName) return;

                const body = { from: city.cityName, to: target.trim() };
                fetchRequest('POST', '/api/v1/city/merge', body, { 'Content-Type': 'application/json' }, 'mergeCityBtn', (res) => {
                    if (res.error) return handleErrors(res);
                    showAlert(t('city.admin.mergeSuccess'), 'success');
                    window.location.href = `/city/${encodeURIComponent(target.trim())}`;
                }, true);
            });
        }

        if (deleteBtn) {
            deleteBtn.addEventListener('click', async () => {
                const ok = window.confirm(t('city.admin.deleteConfirm', { cityName: city.cityName }));
                if (!ok) return;

                const mergeIntoCityName = window.prompt(
                    t('city.admin.deletePrompt'),
                    ''
                );

                const body = mergeIntoCityName && mergeIntoCityName.trim().length > 0
                    ? { mergeIntoCityName: mergeIntoCityName.trim() }
                    : null;

                fetchRequest('DELETE', `/api/v1/city/name/${encodeURIComponent(city.cityName)}`, body, { 'Content-Type': 'application/json' }, 'deleteCityBtn', (res) => {
                    if (res.error) return handleErrors(res);

                    if (body && res?.data?.mergedIntoCityName) {
                        showAlert(t('city.admin.deleteMovedSuccess', { cityName: res.data.mergedIntoCityName }), 'success');
                    } else {
                        showAlert(t('city.admin.deleteSuccess'), 'success');
                    }

                    window.location.href = '/city';
                }, true);
            });
        }
    }
});